import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/views/Layout.vue'
import { canAccess, firstAllowedPath } from '@/menu'

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue'), meta: { title: '登录' } },
  {
    path: '/',
    component: Layout,
    redirect: '/console',
    children: [
      { path: '/console',    component: () => import('@/views/Console.vue'),      meta: { title: '收银台' } },
      { path: '/console/wine-storage', component: () => import('@/views/WineStorage.vue'), meta: { title: '存取酒' } },
      { path: '/teachers',   component: () => import('@/views/TeacherList.vue'),  meta: { title: '老师管理' } },
      { path: '/banners',    component: () => import('@/views/BannerList.vue'),   meta: { title: '轮播图管理' } },
      { path: '/tickets',    component: () => import('@/views/TicketList.vue'),   meta: { title: '门票管理' } },
      { path: '/gifts',      component: () => import('@/views/GiftList.vue'),     meta: { title: '礼物配置' } },
      { path: '/rooms',      component: () => import('@/views/RoomList.vue'),     meta: { title: '包厢配置' } },
      { path: '/products',   component: () => import('@/views/ProductList.vue'),  meta: { title: '商品管理' } },
      { path: '/inventory-items', component: () => import('@/views/InventoryItems.vue'), meta: { title: '存货管理' } },
      { path: '/stock-movements', component: () => import('@/views/StockMovements.vue'), meta: { title: '库存管理' } },
      { path: '/report/product-margin', component: () => import('@/views/ReportProductMargin.vue'), meta: { title: '商品毛利' } },
      { path: '/printers',   component: () => import('@/views/Printers.vue'),    meta: { title: '打印机管理' } },
      { path: '/report/revenue',       component: () => import('@/views/ReportRevenue.vue'),     meta: { title: '营收情况' } },
      { path: '/report/analytics',     component: () => import('@/views/ReportAnalytics.vue'),   meta: { title: '营收分析' } },
      { path: '/report/attendance',    component: () => import('@/views/Attendance.vue'),         meta: { title: '考勤管理' } },
      { path: '/report/gifts',          component: () => import('@/views/ReportGifts.vue'),        meta: { title: '礼物报表' } },
      { path: '/report/gift-records',   component: () => import('@/views/ReportGiftRecords.vue'),  meta: { title: '礼物赠送' } },
      { path: '/report/earnings',       component: () => import('@/views/ReportEarnings.vue'),     meta: { title: '教师收益' } },
      { path: '/report/students',       component: () => import('@/views/ReportStudents.vue'),     meta: { title: '学员报表' } },
      { path: '/report/lesson-income',  component: () => import('@/views/ReportLessonIncome.vue'), meta: { title: '课时收入' } },
      { path: '/report/pending-settlement', component: () => import('@/views/ReportPendingSettlement.vue'), meta: { title: '待结算' } },
      { path: '/report/operation-logs',     component: () => import('@/views/OperationLogs.vue'),          meta: { title: '操作日志' } },
      { path: '/orders/tickets',        component: () => import('@/views/OrderTickets.vue'),       meta: { title: '门票订单' } },
      { path: '/orders/gifts',          component: () => import('@/views/OrderGifts.vue'),         meta: { title: '礼物订单' } },
      { path: '/orders/products',       component: () => import('@/views/OrderProducts.vue'),      meta: { title: '商品订单' } },
      { path: '/orders/room-gifts',     component: () => import('@/views/RoomGiftOrders.vue'),     meta: { title: '赠送套餐单' } },
      { path: '/billing-tiers', component: () => import('@/views/BillingTiers.vue'), meta: { title: '计费档位' } },
      { path: '/groups',        component: () => import('@/views/Groups.vue'),       meta: { title: '老师分组' } },
      { path: '/lessons',       component: () => import('@/views/LessonOrders.vue'), meta: { title: '上课订单' } },
      { path: '/marketing/oa-followers', component: () => import('@/views/OAFollowers.vue'), meta: { title: '公众号会员' } },
      { path: '/marketing/members', component: () => import('@/views/Members.vue'), meta: { title: '小程序会员' } },
      { path: '/settings',   component: () => import('@/views/Settings.vue'),     meta: { title: '参数配置' } },
      { path: '/admin-users', component: () => import('@/views/AdminUsers.vue'),  meta: { title: '用户管理' } },
      { path: '/royalty/balance', component: () => import('@/views/RoyaltyBalance.vue'), meta: { title: '账户余额' } },
      { path: '/royalty/records', component: () => import('@/views/RoyaltyRecords.vue'), meta: { title: '分账记录' } },
      { path: '/royalty/share',   component: () => import('@/views/RoyaltyShare.vue'),   meta: { title: '发起分账' } },
      { path: '/dev-debug',   component: () => import('@/views/DevDebug.vue'),      meta: { title: '开发调试' } },
    ],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to) => {
  if (to.path === '/login') return true
  if (!localStorage.getItem('admin_token')) return '/login'
  const target = firstAllowedPath()
  // 无任何功能权限：回登录页（避免无限重定向黑屏）
  if (!target) return '/login'
  // 根路径直接落到第一个有权页面
  if (to.path === '/') return target
  // 无权访问 → 跳到第一个有权页面
  if (!canAccess(to.path)) return target
  return true
})

export default router
